import { render, staticRenderFns } from "./WhatToDoAfter.vue?vue&type=template&id=d0332c54&scoped=true&"
import script from "./WhatToDoAfter.vue?vue&type=script&lang=js&"
export * from "./WhatToDoAfter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0332c54",
  null
  
)

export default component.exports